document.addEventListener('DOMContentLoaded', () => {
  const media = window.matchMedia('(min-width: 990px)');
  const triggers = Array.from(document.querySelectorAll('.zano-nav__trigger'));

  const topLink = (trigger) => trigger.querySelector(':scope > .header__menu-item--top');

  const syncExpanded = (trigger) => {
    const link = topLink(trigger);
    if (link) link.setAttribute('aria-expanded', trigger.classList.contains('is-active') ? 'true' : 'false');
  };

  const closeTrigger = (trigger) => {
    if (typeof trigger.reset === 'function') trigger.reset();
    trigger.removeAttribute('data-zano-click-open');
    syncExpanded(trigger);
  };

  triggers.forEach((trigger) => {
    const link = topLink(trigger);
    if (!link) return;

    const observer = new MutationObserver(() => syncExpanded(trigger));
    observer.observe(trigger, { attributes: true, attributeFilter: ['class'] });

    link.addEventListener('click', (event) => {
      if (!media.matches) return;
      if (trigger.getAttribute('data-zano-click-open') === 'true') return;

      event.preventDefault();
      trigger.setAttribute('data-zano-click-open', 'true');
      if (typeof trigger.handleMouseover === 'function') trigger.handleMouseover();
      syncExpanded(trigger);
    });

    trigger.addEventListener('mouseleave', () => {
      trigger.removeAttribute('data-zano-click-open');
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeTrigger(trigger);
      link.focus();
    });
  });

  document.addEventListener('click', (event) => {
    if (!media.matches || event.target.closest('.zano-nav__trigger')) return;
    triggers.forEach(closeTrigger);
  });
});
